import React, { useEffect, useState } from 'react';
import './TeklifBasvurular.css';

const TeklifBasvurular = () => {
  const [basvurular, setBasvurular] = useState([]);

  useEffect(() => {
    const veri = JSON.parse(localStorage.getItem('teklifBasvurular') || '[]');
    setBasvurular(veri);
  }, []);

  const sil = (index) => {
    if (window.confirm('Bu başvuruyu silmek istiyor musunuz?')) {
      const yeniListe = [...basvurular];
      yeniListe.splice(index, 1);
      setBasvurular(yeniListe);
      localStorage.setItem('teklifBasvurular', JSON.stringify(yeniListe));
    }
  };

  const isaretleOkundu = (index) => {
    const yeniListe = [...basvurular];
    yeniListe[index].okundu = true;
    setBasvurular(yeniListe);
    localStorage.setItem('teklifBasvurular', JSON.stringify(yeniListe));
  };

  return (
    <div className="teklif-basvurular-wrapper">
      <h2>📩 Gelen Teklif Başvuruları</h2>

      {basvurular.length === 0 ? (
        <div className="bos-mesaj">Hiç başvuru yapılmamış.</div>
      ) : (
        <div className="tablo-kapsayici">
          <table className="teklif-tablosu">
            <thead>
              <tr>
                <th>Durum</th>
                <th>İsim</th>
                <th>Mail</th>
                <th>Telefon</th>
                <th>Konu</th>
                <th>Mesaj</th>
                <th>Tarih</th>
                <th>İşlem</th>
              </tr>
            </thead>
            <tbody>
              {basvurular.map((b, i) => (
                <tr key={i}>
                  <td>
                    {b.okundu ? (
                      <span className="okundu">🟢</span>
                    ) : (
                      <span className="yenimesaj">🔴</span>
                    )}
                  </td>
                  <td>{b.isim}</td>
                  <td>{b.mail}</td>
                  <td>{b.telefon}</td>
                  <td>{b.konu}</td>
                  <td>{b.mesaj}</td>
                  <td>{b.tarih}</td>
                  <td>
                    {!b.okundu && (
                      <button onClick={() => isaretleOkundu(i)} className="okundu-btn">
                        ✅ Okundu
                      </button>
                    )}
                    <button onClick={() => sil(i)} className="sil-btn">🗑️ Sil</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default TeklifBasvurular;
